import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class RolesService {
  constructor(private http: HttpClient) {}

  public fetchRoles(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/role/list`
    return this.http.post(url, params)
  }

  public fetchPermissions(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/permissions`
    return this.http.get(url, params)
  }

  public fetchRole(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/role/${id}`
    return this.http.get(url, {})
  }

  public deleteRole(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/role/${id}`
    return this.http.delete(url)
  }

  public createRole(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/role`
    return this.http.post(url, params)
  }

  public updateRole(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/um/role/${id}`
    return this.http.put(url, params)
  }
}
